module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img38.17776733.jpg";